export const SESSION_EXPIRED_ERROR_NAME = 'SessionExpiredError';
export class SessionExpiredError extends Error {
    constructor(message = 'Session expired') {
        super(message);
        this.name = SESSION_EXPIRED_ERROR_NAME;
    }
}
/**
 * Matches on `name` rather than `instanceof`: an error thrown inside a server
 * function loses its prototype chain on the way back to the client, so
 * `instanceof` is false there for what is the same error.
 */
export const isSessionExpiredError = (error) => {
    if (!error || typeof error !== 'object') {
        return false;
    }
    return error.name === SESSION_EXPIRED_ERROR_NAME;
};
//# sourceMappingURL=errors.js.map